import * as React from 'react';

export const MinusIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg width="18" height="2" viewBox="0 0 18 2" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Минус</title>
    <rect x="1" y="0" width="16" height="2" rx="2" fill="currentColor" fillRule="evenodd" />
  </svg>
);
